import IconButton from '@mui/material/IconButton';
import { SvgIcon } from '@mui/material';
import { ReactComponent as GraphIcon } from '../icons/graph.svg';
import type React from 'react';

import styled from 'styled-components';
import { observer } from 'mobx-react';

interface IProps {
  isExpanded: boolean;
  handleIsExpanded: () => void;
}

export const GraphButton = observer(({ isExpanded, handleIsExpanded }: IProps): React.ReactElement => {
  return (
    <IconButtonContainer $isExpanded={isExpanded}>
      <IconButton size="large" aria-label="extend-graph-btn" onClick={handleIsExpanded}>
        <SvgIcon component={GraphIcon} fontSize="large" inheritViewBox color={isExpanded ? 'primary' : 'secondary'} />
      </IconButton>
    </IconButtonContainer>
  );
});

const IconButtonContainer = styled.div<{ $isExpanded: boolean }>`
  position: absolute;
  top: ${(props): string => (props.$isExpanded ? '0.4em' : '-0.9em')};
  right: 1em;
  z-index: 2;
`;
